var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#F5F5F9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8255 26.216C22.8595 26.216 24.2095 25.568 25.3975 24.524C25.5955 24.344 25.7575 24.074 25.7575 23.732C25.7575 23.174 25.2715 22.706 24.7135 22.706C24.4435 22.706 24.2095 22.814 24.0475 22.958C23.1295 23.732 22.2295 24.164 20.8975 24.164C18.4855 24.164 16.7395 22.166 16.7395 19.7V19.664C16.7395 17.198 18.5035 15.218 20.8975 15.218C22.1035 15.218 23.0395 15.65 23.9035 16.352C24.0475 16.46 24.2635 16.568 24.5695 16.568C25.1815 16.568 25.6675 16.1 25.6675 15.488C25.6675 15.092 25.4695 14.786 25.2355 14.606C24.1375 13.76 22.8595 13.184 20.9155 13.184C17.0995 13.184 14.4175 16.118 14.4175 19.7V19.736C14.4175 23.354 17.1535 26.216 20.8255 26.216Z",
  fill: "#171A20"
});

var SvgCIcon = function SvgCIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c-icon.609df007.svg";
export { ForwardRef as ReactComponent };